export const ECO_BEAM_PRODUCT_TYPE = 'eco-beam';

export const ECO_BEAM_PRICING_TIERS = [
    { minMounts: 1, pricePerMount: 1500 },
    { minMounts: 5, pricePerMount: 1125 },
    { minMounts: 50, pricePerMount: 900 },
];

export const isEcoBeamDesign = (design) => {
    const productType = design?.product_type ?? design?.beam_series;
    return productType === ECO_BEAM_PRODUCT_TYPE;
};

export const getEcoBeamPricePerMount = (mountQuantity) => {
    const qty = Math.max(0, Number(mountQuantity) || 0);
    if (qty === 0) {
        return ECO_BEAM_PRICING_TIERS[0].pricePerMount;
    }

    let applicableTier = ECO_BEAM_PRICING_TIERS[0];
    for (const tier of ECO_BEAM_PRICING_TIERS) {
        if (qty >= tier.minMounts) {
            applicableTier = tier;
        }
    }
    return applicableTier.pricePerMount;
};

export const getEcoBeamLineTotal = (mountQuantity) => {
    const qty = Math.max(0, Number(mountQuantity) || 0);
    if (qty === 0) return 0;
    return getEcoBeamPricePerMount(qty) * qty;
};
